import { render, staticRenderFns } from "./vpnList.vue?vue&type=template&id=e01bd63e&scoped=true&"
import script from "./vpnList.vue?vue&type=script&lang=js&"
export * from "./vpnList.vue?vue&type=script&lang=js&"
import style0 from "./vpnList.vue?vue&type=style&index=0&id=e01bd63e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01bd63e",
  null
  
)

export default component.exports